import { JSX } from "react";
import { useTranslation } from "react-i18next";

import { IconLaptop, IconSpeaker, IconTickets, IconUser, IconWallet } from "@/components/icons";

import { IconProps } from "@/@types/general.ts";
import { ROUTES } from "@/config/routes.ts";

interface StaffNavigationLink {
  to: string;
  IconComponent: (props: IconProps) => JSX.Element;
  title: string;
}

export const useStaffNavigationLinks = (): StaffNavigationLink[] => {
  const { t } = useTranslation();

  return [
    {
      to: ROUTES.STAFF.USER_SETTINGS,
      IconComponent: IconUser,
      title: t("account.title"),
    },
    {
      to: ROUTES.STAFF.PAYMENT_HISTORY,
      IconComponent: IconWallet,
      title: t("Payment.balance"),
    },
    {
      to: ROUTES.STAFF.AVAILABLE_SUBSCRIPTIONS,
      IconComponent: IconSpeaker,
      title: t("Subscription.my-subs"),
    },
    {
      to: ROUTES.STAFF.SESSIONS,
      IconComponent: IconLaptop,
      title: t("Sessions.sessions"),
    },
    {
      to: ROUTES.STAFF.ORDER_MOVIE,
      IconComponent: IconTickets,
      title: t("Orders.movie"),
    },
  ];
};
